import React, {useMemo, useState} from "react";
import {TreeView} from "./treeView";
import {TreeNode} from "./types";
import {filterTree} from "./filterTree";
import {getExpandedFromSearch} from "./expandTreeOnSearch";
import "./treeModal.css";
import { useTranslation } from 'react-i18next';

type Props = {
    open: boolean;
    onClose: () => void;
    tree: TreeNode[];
    toggleNode: (id: string) => void;
    getSelectionState: (id: string) => {
        checked: boolean;
        indeterminate: boolean;
    };
};

export function TreeModal({
                              open,
                              onClose,
                              tree,
                              toggleNode,
                              getSelectionState
                          }: Props) {
    const { t } = useTranslation();
    const [search, setSearch] = useState("");

    const filteredTree = useMemo(
        () => filterTree(tree, search),
        [tree, search]
    );

    const autoExpanded = useMemo(
        () => getExpandedFromSearch(tree, search),
        [tree, search]
    );

    if (!open) return null;

    return (
        <div className="tm-overlay" onClick={onClose}>
            <div className="tm-modal" onClick={(e) => e.stopPropagation()}>

                <div className="tm-header">
                    <div className="tm-title">{t('mfTitle')}</div>
                    <button className="tm-close" onClick={onClose}>✕</button>
                </div>

                <div className="tm-info">
                    <p>{t('mfInfo1')}</p>
                    <p>{t('mfInfo2')}</p>
                </div>

                <div className="tm-search">
                    <div className="tm-search-wrapper">
                        <input
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            placeholder={t('Search')}
                            className="tm-search-input"
                        />

                        {search.length > 0 && (
                            <button
                                className="tm-search-clear"
                                onClick={() => setSearch("")}
                                aria-label="Clear search"
                            >
                                ✕
                            </button>
                        )}
                    </div>
                </div>

                <div className="tm-body">
                    <TreeView
                        nodes={filteredTree}
                        toggleNode={toggleNode}
                        getSelectionState={getSelectionState}
                        externalExpanded={autoExpanded}
                    />
                </div>

                <div className="tm-footer">
                    <button className="tm-primary" onClick={onClose}>
                        {t('Close')}
                    </button>
                </div>

            </div>
        </div>
    );
}